import { leg } from "./leg.service";
import { ticketRequest } from "./ticket-request.service";
import { wager } from "./wager.service";
import { countBets } from "./wagercosting.service";

export class abcWagersService {
  constructor() {}

  buildABCWagers(
    runnerList: string[][],
    pool: any,
    userInput: number,
    runnersList: any[],
    legsArray: any[],
    selectedEvent: any,
    selectedRace: any,
    selectedModifier: any,
    isBlockJurisdiction: boolean,
    isBlockJurisdictionMsg: string
  ): any {
    //TODO remove this line
    pool.ABC = true;
    let i;
    let j;
    const aWagers: Record<number, string[]> = {};
    const bWagers: Record<number, string[]> = {};
    const cWagers: Record<number, string[]> = {};
    const max = runnerList.length - 1;
    if (runnerList.length != pool.PoolRaces * pool.Legs) return -1;
    for (i = 0; i < pool.Legs; i++) {
      if (runnerList[i].length < 1) return -1;
    }

    for(i = 0; i <= max; i++) {
      const raceId = i;
      for(j = 0; j < runnerList[i].length; j++) {
        const abcRunner = runnerList[i][j].split('%');
        const abcValue = abcRunner[0];
        const runnerId = abcRunner[1];

        switch(abcValue.toLowerCase()) {
          case 'a':
            if(aWagers[raceId] == null) {
                aWagers[raceId] = [];
            }
            aWagers[raceId].push(runnerId);
            break;
          case 'b':
            if(bWagers[raceId] == null) {
                bWagers[raceId] = [];
            }
            bWagers[raceId].push(runnerId);
            break;
          case 'c':
            if(cWagers[raceId] == null) {
                cWagers[raceId] = [];
            }
            cWagers[raceId].push(runnerId);
            break;
          default:
            break;
        }
      }
    }

    // check if all races have As, return false if it does not have
    if(Object.keys(aWagers).length != pool.PoolRaces * pool.Legs) return false;

    const combine = pool.Combine ?? 1;
    const ordered = pool.Unordered === undefined ? 1 : !pool.Unordered;

    const runnerAllAs: any[] = [];
    const runnerAllAsBs: any[] = [];
    const runnerAsWith1B: any[] = [];
    const runnerAsWith2B: any[] = [];
    const runnerAsWith1C: any[] = [];

    // all As
    runnerAllAs.push(this.clone(Object.values(aWagers)));

    // As with 1B
    let newCombi = [];
    let found = false;
    for(i = 0; i < Object.keys(bWagers).length; i++) {
      found = false;
      newCombi = [];
      for(j = 0; j < runnerAllAs[0].length; j++) {
        if(j === +Object.keys(bWagers)[i]) {
            found = true;
            newCombi = this.clone(runnerAllAs[0]);
            newCombi[j] = this.clone(Object.values(bWagers)[i]);
            break;
        }
      }

      if(found) {
        runnerAsWith1B.push(newCombi);
      }
    }

    // As with 2Bs

    // bwagers length should be greater >= 2
    for(i = 0; i < Object.keys(bWagers).length; i++) {
      newCombi = [];
      for(j = 0; j < runnerAllAs[0].length; j++) {
        if(j === +Object.keys(bWagers)[i]) {
          newCombi = this.clone(runnerAllAs[0]);
          newCombi[j] = this.clone(Object.values(bWagers)[i]);

          let next = i+1;
          while(next < Object.keys(bWagers).length) {
            const newCombi2 = this.clone(newCombi);
            newCombi2[Object.keys(bWagers)[next]] = this.clone(Object.values(bWagers)[next]);
            runnerAsWith2B.push(newCombi2);
            next++;
          }
        }
      }
    }

    // As with 1C
    for(i = 0; i < Object.keys(cWagers).length; i++) {
      found = false;
      newCombi = [];
      for(j = 0; j < runnerAllAs[0].length; j++) {
        if(j === +Object.keys(cWagers)[i]) {
          found = true;
          newCombi = this.clone(runnerAllAs[0]);
          newCombi[j] = this.clone(Object.values(cWagers)[i]);
          break;
        }
      }

      if(found) {
        runnerAsWith1C.push(newCombi);
      }
    }

    const allRunnersABC = [];
    allRunnersABC.push(runnerAllAs);
    allRunnersABC.push(runnerAllAsBs);
    allRunnersABC.push(runnerAsWith1B);
    allRunnersABC.push(runnerAsWith2B);
    allRunnersABC.push(runnerAsWith1C);

    let allACombos = 0;
    const allAallBCombos = 0;
    let withOneBCombos = 0;
    let withTwoBCombos = 0;
    let withOneCCombos = 0;
    // get total factoredcombo
    for(i = 0; i < allRunnersABC.length; i++) {
      for(j = 0; j < allRunnersABC[i].length; j++) {
        // ALL As factored combo is 1, else is 0.5
        const countedBets = countBets(
          allRunnersABC[i][j], pool.Legs, combine, pool.Maximum, ordered
        );
        switch(i) {
          case 0:
            allACombos += countedBets;
            break;
          case 1:
            break;
          case 2:
            withOneBCombos += countedBets;
            break;
          case 3:
            withTwoBCombos += countedBets;
            break;
          case 4:
            withOneCCombos += countedBets;
            break;
        }
      }
    }

    let allABase = pool.MultipleBetMinimum;
    let allAallBBase = pool.MultipleBetMinimum;
    let withOneBBase = pool.MultipleBetMinimum;
    let withTwoBBase = pool.MultipleBetMinimum;
    let withOneCBase = pool.MultipleBetMinimum;
    let totalBetAmount = (allABase * allACombos) +
    (allAallBBase * allAallBCombos) +
    (withOneBBase * withOneBCombos) +
    (withTwoBBase * withTwoBCombos) +
    (withOneCBase * withOneCCombos);

    let curBetType = 0;
    let passNum = 0;
    let keepgoing = totalBetAmount < userInput;
    while(keepgoing && (passNum <= 0) && (totalBetAmount > 0.001)) {
      passNum++;
      switch(curBetType) {
        case 0:
          if(allACombos > 0) {
            totalBetAmount = ((allABase + pool.MultipleBetMinimum)  * allACombos) +
            (allAallBBase * allAallBCombos) +
            (withOneBBase * withOneBCombos) +
            (withTwoBBase * withTwoBCombos) +
            (withOneCBase * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            allABase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
        case 1:
          if(allACombos > 0) {
            totalBetAmount = ((allABase + pool.MultipleBetMinimum)  * allACombos) +
            (allAallBBase * allAallBCombos) +
            (withOneBBase * withOneBCombos) +
            (withTwoBBase * withTwoBCombos) +
            (withOneCBase * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            allABase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
        case 2:
          if(allAallBCombos > 0) {
            totalBetAmount = (allABase  * allACombos) +
            ((allAallBBase + pool.MultipleBetMinimum) * allAallBCombos) +
            (withOneBBase * withOneBCombos) + (withTwoBBase * withTwoBCombos) +
            (withOneCBase * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            allAallBBase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
        case 3:
          if(withOneBCombos > 0) {
            totalBetAmount = (allABase * allACombos) +
            (allAallBBase * allAallBCombos) +
            ((withOneBBase + pool.MultipleBetMinimum) * withOneBCombos) +
            (withTwoBBase * withTwoBCombos) +
            (withOneCBase * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            withOneBBase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
        case 4:
          if(withTwoBCombos > 0) {
            totalBetAmount = (allABase * allACombos) +
            (allAallBBase * allAallBCombos) +
            (withOneBBase * withOneBCombos) +
            ((withTwoBBase + pool.MultipleBetMinimum) * withTwoBCombos) +
            (withOneCBase * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            withTwoBBase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
        case 5:
          if(withOneCCombos > 0) {
            totalBetAmount = (allABase  * allACombos) +
            (allAallBBase * allAallBCombos) +
            (withOneBBase * withOneBCombos) +
            (withTwoBBase * withTwoBCombos) +
            ((withOneCBase + pool.MultipleBetMinimum) * withOneCCombos);
            if(Math.round(totalBetAmount * 100) > Math.round(userInput * 100)) break;
            withOneCBase += pool.MultipleBetMinimum;
          }
          passNum = 0;
          break;
      }
      totalBetAmount = (allABase  * allACombos) +
      (allAallBBase * allAallBCombos) +
      (withOneBBase * withOneBCombos) +
      (withTwoBBase * withTwoBCombos) +
      (withOneCBase * withOneCCombos);
      keepgoing = Math.round(totalBetAmount * 100) < Math.round(userInput * 100)
      curBetType = curBetType == 5 ? 0 : curBetType + 1;
    }

    for(i = 0; i < allRunnersABC.length; i++) {
      const abcWagers = [];
      for(j = 0; j < allRunnersABC[i].length; j++) {
        legsArray = [];
        for(let k = 0; k < allRunnersABC[i][j].length; k++) {
          legsArray.push(new leg(false, allRunnersABC[i][j][k]));
        }

        const wagerSample = new wager(0, 0, 0, undefined, [], null, 0)
        wagerSample.Bets = countBets(
          allRunnersABC[i][j],
          pool.Legs,
          combine,
          pool.Maximum,
          ordered
        );
        wagerSample.RaceId = selectedRace.RaceId || 0;
        wagerSample.PoolId = pool.PoolId;
        // ALL As factored combo is 1, else is 0.5

        const betMinimum = wagerSample.Bets == 1 ? pool.SingleBetMinimum : pool.MultipleBetMinimum;

        switch(i) {
          case 0:
            wagerSample.BaseAmount = allABase > betMinimum ? allABase : betMinimum;
            break;
          case 1:
            wagerSample.BaseAmount = allAallBBase > betMinimum ? allAallBBase : betMinimum;
            break;
          case 2:
            wagerSample.BaseAmount = withOneBBase > betMinimum ? withOneBBase : betMinimum;
            break;
          case 3:
            wagerSample.BaseAmount = withTwoBBase > betMinimum ? withTwoBBase : betMinimum;
            break;
          case 4:
            wagerSample.BaseAmount = withOneCBase > betMinimum ? withOneCBase : betMinimum;
            break;
        }
        wagerSample.BaseAmount = wagerSample.BaseAmount.toFixed(2);
        wagerSample.Modifier = selectedModifier;
        wagerSample.calcAmount();
        // if (IsDefaultCond) {
        //   if (
        //     typeof wagerSample.Condition === 'undefined' ||
        //     wagerSample.Condition === null ||
        //     typeof wagerSample.Condition.MTPCondition === 'undefined' ||
        //     wagerSample.Condition.MTPCondition === ''
        //   ) {
        //     wagerSample.Condition = {};
        //     wagerSample.Condition['MTPCondition'] = DefaultCondValue;
        //     wagerSample.Condition['MTPOperator'] = DefaultCondOperator;
        //   }
        // }

        wagerSample.Legs = legsArray;
        if (
          wagerSample.getError(
            selectedEvent,
            selectedRace,
            pool,
            allRunnersABC[i][j],
            isBlockJurisdiction,
            isBlockJurisdictionMsg
          ) == -1
        ) {
          wagerSample.Bets = 0;
        }
        else {
          wagerSample.Error = null;
        }

        abcWagers.push(wagerSample);

      }

      // allRunnersABC[i].ABCTicket
      (allRunnersABC[i] as any).ABCTicket = new ticketRequest(
        selectedEvent.ToteResponse.RunId,
        selectedEvent.ToteResponse.EventDetail.EventId,
        selectedRace.RaceId,
        abcWagers,
        3,
        undefined
      );
    }

    return allRunnersABC;
  }

  clone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }
}
